import { useCallback, useEffect, useState } from "react"
import { Outlet, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { CabinetHeader } from "./CabinetHeader"
import { CabinetSidebar } from "./CabinetSidebar"
import { getCabinetNav, isSectionPath, readLastCabinet, resolveCabinet, writeLastCabinet } from "./cabinetNav"
import { useCabinetAccess } from "./useCabinetAccess"
import { useCabinetCounters } from "./useCabinetCounters"

/** Режим «кабинет»: своя шапка, переключатель ролей и боковое меню текущего кабинета. */
export default function CabinetLayout() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const access = useCabinetAccess()
  const counters = useCabinetCounters(access)
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const current = access.isLoading ? null : resolveCabinet(pathname, access, readLastCabinet())
  const isSummary = !access.isLoading && current === null
  const sectionPage = isSectionPath(pathname)
  const groups = current ? getCabinetNav(current, access) : []
  const closeSidebar = useCallback(() => setSidebarOpen(false), [])

  useEffect(() => {
    if (current) writeLastCabinet(current)
  }, [current])

  useEffect(() => {
    setSidebarOpen(false)
  }, [pathname])

  return (
    <div data-workspace={current ?? "summary"} className="workspace-shell cabinet-shell min-h-screen flex flex-col text-lib-text">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 z-[60] px-4 py-2 rounded-md bg-lib-card text-lib-accent text-sm font-semibold shadow-md border border-lib-accent"
      >
        {t("common.skipToContent")}
      </a>
      <CabinetHeader
        ready={!access.isLoading}
        current={current}
        available={access.available}
        counters={counters}
        canCreateEvents={access.canCreateEvents}
        canModerateEvents={access.canModerateEvents}
        isAdmin={access.isAdmin}
        hasSidebar={Boolean(current)}
        sidebarOpen={sidebarOpen}
        onToggleSidebar={() => setSidebarOpen((open) => !open)}
      />
      <div className="flex flex-1 pt-14">
        {current ? (
          <CabinetSidebar current={current} groups={groups} mobileOpen={sidebarOpen} onClose={closeSidebar} />
        ) : null}
        <main id="main-content" tabIndex={-1} className="flex-1 min-w-0 focus:outline-none">
          <div
            className={
              sectionPage
                ? "w-full"
                : `mx-auto w-full px-4 sm:px-6 lg:px-10 py-8 md:py-10 ${isSummary ? "max-w-6xl" : "max-w-[1320px]"}`
            }
          >
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
